export default "__VITE_ASSET__CQfx7R1S__"